import script from "./OrderBill.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderBill.vue?vue&type=script&setup=true&lang=js"

import "./OrderBill.vue?vue&type=style&index=0&id=0af94589&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0af94589"]])

export default __exports__